import { WSForm, WSSelect, WSText } from "@wingspanhq/fe-component-library";
import { Form1099Status } from "@wingspanhq/payments/dist/interfaces";
import { LABEL_COLOR, LIST_MT } from "../../../../components/LabelValueList";
import getStatusLabel from "../../../../utils/getStatusLabel";

const FormField1099Status: React.FC<{ statusOptions: Form1099Status[] }> = ({
  statusOptions
}) => {
  const inputOptions = statusOptions.map(value => ({
    label: getStatusLabel(value),
    value
  }));

  return (
    <>
      <WSText color={LABEL_COLOR} mt={LIST_MT}>
        Status
      </WSText>
      <WSForm.Field
        name="form1099Status"
        component={WSSelect}
        componentProps={{ options: inputOptions }}
      />
    </>
  );
};

export default FormField1099Status;
